import { render, staticRenderFns } from "./TeacherHasStartedLessonNotification.vue?vue&type=template&id=213a0a59&"
import script from "./TeacherHasStartedLessonNotification.vue?vue&type=script&lang=js&"
export * from "./TeacherHasStartedLessonNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports